import { render, staticRenderFns } from "./material-card.vue?vue&type=template&id=44c18fd4&scoped=true&"
import script from "./material-card.vue?vue&type=script&lang=js&"
export * from "./material-card.vue?vue&type=script&lang=js&"
import style0 from "./material-card.vue?vue&type=style&index=0&id=44c18fd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c18fd4",
  null
  
)

export default component.exports